<template>
    <ul class="navigation">
        <router-link tag="li" active-class="navigation__active" :to="{name: 'dashboard'}">
            <a><i class="zmdi zmdi-home"></i> Home</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'growers.browse'}">
            <a><i class="zmdi zmdi-accounts"></i> Growers</a>
        </router-link>

        <li class="navigation__sub" :class="{'navigation__sub--active': isActiveItem('/setup')}">
            <b-link @click="toggleSetup">
                <i class="zmdi zmdi-settings"></i> Setup
            </b-link>

            <keep-alive>
                <ul v-if="showSetup" class="animated">
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'setup'}" exact>
                        <a>Account</a>
                    </router-link>
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'setup', params: {view: 'growsafe'}}">
                        <a>Growsafe Certificates</a>
                    </router-link>
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'setup', params: {view: 'equipment'}}">
                        <a>Equipment</a>
                    </router-link>
                </ul>
            </keep-alive>
        </li>
    </ul>
</template>

<script>
export default {
  name: 'ContractorAppSidebar',
  apollo: {},
  data() {
    return {
      loading: 0,
      showSetup: this.isActiveItem('/setup'),
    };
  },
  computed: {},
  methods: {
    isActiveItem(url) {
      return this.$route.path.startsWith(url);
    },
    toggleSetup() {
      this.showSetup = !this.showSetup;
    },
  },
};
</script>
